<template>
    <v-dialog persistent v-model="dialog" max-width="290">
        <v-card>

            <v-card-title class="headline">
                {{$t('Pages.Users.title_upload_dialog')}}
                <v-btn small absolute right icon dark @click="onClose">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-flex class="text-xs-center">
                    <v-btn fab color="purple" small @click="$refs.file.click()">
                        <v-icon dark>mdi-upload</v-icon>
                    </v-btn>
                    <span>{{name ? name : $t('Pages.Users.model.upload.file')}}</span>
                </v-flex>
                <input
                        id="file"
                        type="file"
                        style="display: none"
                        ref="file"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        @change="onFilePicked"
                >

                <v-text-field
                        v-validate="'required'"
                        v-model="request.sheet"
                        :error-messages="errors.first('sheet')"
                        :label="$t('Pages.Users.model.upload.sheet')"
                        type="number"
                        color="info"
                        required
                        name="sheet"
                />
                <v-switch
                        color="info"
                        ripple
                        v-model="request.agency"
                        :label="$t('Pages.Users.model.agency')"
                ></v-switch>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                        color="info darken-1"
                        @click="save"
                >
                    {{$t('Core.Fields.save')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Form from '../../services/Form'
    import _ from 'lodash';
export default {
    name: 'upload-dialog',
  components: {},
  props: {
      dialog: {
          type: Boolean,
          default: false
      },
  },
  data: () => ({
    request: {sheet: 1, agency: false},
    name: null,
  }),
  computed: {
  },
  created () {

  },
    methods: {
        onClose(refresh = false){
            this.$emit('close', refresh);
        },
        onFilePicked (e) {
            const files = e.target.files
            if(files[0] !== undefined) {
                this.name = files[0].name
            } else {
                this.name = null
            }
        },
        save(){

            this.$validator.validateAll().then((result) => {
                if (result) {
                    let data = {
                        file: this.$refs.file,
                        sheet: this.request.sheet,
                        agency: this.request.agency
                    }
                    this.repositories.user.upload(Form.prepare(data)).then((response) => {
                        this.$toast.success(response.data.message);
                    });
                }
            });
        }
    },
    watch:{

    }
}
</script>

<style lang="scss">

</style>
